
import { calcColorDiffTexto } from "@/utils/fontColorDifCalculator";
import Vue from "vue";
import { Component, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";

const Notifications = namespace("Notifications");

@Component({})
export default class NotificationComponent extends Vue {
  @Notifications.Getter
  private isShowMessage!: boolean;

  @Notifications.Getter
  private getMessage!: string;

  @Notifications.Getter
  private getColor!: string;

  @Notifications.Getter
  private getTimeout!: number;

  @Notifications.Action
  private resetState!: () => Promise<any>;

  getTextColor() {
    const themeColor = this.$vuetify.theme.themes.light[this.getColor];
    return calcColorDiffTexto(themeColor || this.getColor ) || 'white';
  }

  private snackbar = {
    visible: false,
    text: "",
    timeout: 4000,
    color: "success",
    textColor: "white",
  };

  @Watch("isShowMessage")
  onShowMessage() {
    if (this.isShowMessage) {
      this.snackbar.text = this.getMessage;
      this.snackbar.visible = this.isShowMessage;
      this.snackbar.color = this.getColor;
      this.snackbar.timeout = this.getTimeout;
      this.snackbar.textColor = this.getTextColor();
      this.resetState();
    }
  }

  onSnackbarDismissed() {
    this.snackbar.visible = false;
  }
}
